import WebsiteBehaviors from "../website-behaviors/index.js";

class WashingtonPost extends WebsiteBehaviors {
	identifier() {
		return "WashingtonPost";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host.match(/^(www\.)?washingtonpost\.com$/);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'processOrgProxy' implicitly has an 'any... Remove this comment to see the full error message
	getPageUrl(processOrgProxy) {
		const metatag = document.querySelector('meta[property="og:url"][content^="http"]');
		if (metatag)
			return processOrgProxy(metatag.getAttribute("content"));

		return super.getPageUrl(processOrgProxy);
	}
}

export default WashingtonPost;
